<template>
  <div>
    <img
      :src="ethocaLogo"
      width="140"
      alt="Ethoca by Mastercard"
      data-rf-ethoca-logo
    />
    <h2 class="text-heading-1 text-beige-90 mt-4">Mastercard Ethoca</h2>
    <p class="text-body-2 text-beige-70 mt-1 max-w-[900px]">
      Ethoca connects merchants directly to card-issuing banks. When a subscriber cancels from
      their banking app, Recurly receives it as a real cancellation instead of a failed payment.
    </p>

    <h3 class="text-heading-3 text-beige-90 mt-7">Show prompt in banking apps</h3>
    <div class="mt-2 flex items-center gap-6">
      <RfCheckbox
        :modelValue="enabled"
        data-rf-ethoca-active
        @update:modelValue="value => (enabled = !!value)"
      >
        Active
      </RfCheckbox>
      <router-link
        class="text-blue-60"
        :to="`/apps/${app.id}/prompts`"
        data-rf-ethoca-view-prompts
      >
        View Prompts
      </router-link>
    </div>

    <h3 class="text-heading-3 text-beige-90 mt-7 flex items-center gap-1">
      Supported markets
      <RfTooltip position="top">
        <template #activator>
          <RfHelpIcon class="text-beige-50 align-middle h-6! w-6!" />
        </template>
        <template #tooltip>
          Countries where the Ethoca prompt can be shown. Additional markets are coming soon.
        </template>
      </RfTooltip>
    </h3>
    <div class="mt-2">
      <RfSelect
        :modelValue="'us'"
        :items="SUPPORTED_MARKETS"
        variant="outlined"
        size="small"
        sameWidth
        class="w-full"
        disabled
        data-rf-ethoca-markets
      />
    </div>

    <div class="mt-8 flex justify-end">
      <RfButtonNew size="large" data-rf-ethoca-save @click="emit('onSettingsUpdateClick')">
        <span class="inline-flex items-center justify-center gap-4 py-1.5 pr-2">
          <RfSaveIcon class="h-6! w-6!" />
          <span>Save changes</span>
        </span>
      </RfButtonNew>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import RfButtonNew from "@/components/buttons/RfButtonNew.vue";
import RfCheckbox from "@/components/inputs/RfCheckbox.vue";
import RfSelect from "@/components/inputs/RfSelect.vue";
import RfSaveIcon from "@/components/icons/RfSaveIcon.vue";
import RfHelpIcon from "@/components/icons/RfHelpIcon.vue";
import RfTooltip from "@/components/tooltip/RfTooltip.vue";
import ethocaLogo from "@/assets/images/logos/ethoca.svg";

const props = defineProps({
  app: { type: Object, required: true },
});

const emit = defineEmits(["onSettingsUpdateClick"]);

// Markets Ethoca supports today (US issuer portfolios only); auto-pulled from RSM data in a later slice.
const SUPPORTED_MARKETS = [{ text: "United States", value: "us" }];

const enabled = ref(!!props.app.flags?.ethoca_enabled);

function fillModel(model) {
  model.flags = { ...(model.flags || {}), ethoca_enabled: enabled.value };
}

defineExpose({ fillModel });
</script>
